export enum UtilizacaoVeiculo {
  PARTICULAR = "PARTICULAR",
  COMERCIAL = "COMERCIAL",
  TRANSPORTE_APP = "TRANSPORTE_APP",
  TAXI = "TAXI",
}
